import React, { useEffect, useState } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { Container, Header, Heading, Content } from "../Summarize/Style";
import { Iframe } from "../Iframe/Style";
import BackIcon from "../../assets/back-icon.svg";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";


export default function TestEmail() {
  const { t,i18n } = useTranslation();
  const email = localStorage.getItem("email");
  const password = localStorage.getItem("password");
  const mongoId = localStorage.getItem("id");
  const token =localStorage.getItem("user_token") // from api/login
  const emailToken=localStorage.getItem("token")  //from auth/login
  const [iframeSrc, setIframeSrc] = useState(
    `https://emailsorter.aivoria.nl/sign-in/?email=${email}&password=${password}&mongoId=${mongoId}&lang=${i18n.language}&token=${token}&emailToken=${emailToken}`
  );

  useEffect(()=>{
    setIframeSrc(
      `https://emailsorter.aivoria.nl/sign-in/?email=${email}&password=${password}&mongoId=${mongoId}&lang=${i18n.language}&token=${token}&emailToken=${emailToken}`
    );

  },[i18n.language, email])

  console.log("Credentials for Email", email, password);

  const { isSidebarOpen } = useOutletContext();
  const navigate = useNavigate();

  return (
    <Container isOpen={isSidebarOpen} style={{ marginRight: "1.4rem" }}>
      <Header style={{ alignItems: "center", justifyContent: "space-between" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        >
          <img src={BackIcon} alt={t("emailAutomation.back")} />

          <Heading style={{ marginBottom: 0 }}>
            {t("emailAutomation.title")}
          </Heading>

          <Tooltip
            title={t("emailAutomation.tooltip")}
            placement="top"
          >
            <InfoCircleOutlined
              style={{
                fontSize: 14,
                color: "#8c8c8c",
                cursor: "pointer",
              }}
              onClick={(e) => e.stopPropagation()} // prevent back navigation
            />
          </Tooltip>
        </div>

      </Header>
      <Content>
        <Iframe src={iframeSrc} />
      </Content>
    </Container>
  );
}
